import React, { useState, useEffect } from "react";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelDos.scss";

// Assets
import hex from "../../assets/images/level-dos/hexagon.svg";
import arrow from "../../assets/images/level-dos/arrow.svg";

// Components
import Navbar from "../../components/common/Navbar";

// Consts
import { TILES } from "../../utils/consts";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const PATTERN = [
  7,
  22,
  20,
  11,
  17,
  1,
  16,
  19,
  9,
  5,
  10,
  13,
  3,
  23,
  21,
  24,
  4,
  14,
  12,
  2,
  0,
  15,
  18,
  8,
  6,
];

const LevelDos = (props) => {
  const [tiles, setTiles] = useState(TILES);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentTile, setCurrentTile] = useState(PATTERN[0]);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [datapts, setDatapts] = useState({
    firstBoxClicks: 0, // Clicks before first right block is clicked
    firstBoxTime: 0, // Time taken to click first right block (where all arrows are pointed
    totalClicks: 0,
    totalTime: 0,
    totalHints: 0,
    beforeHintsClicks: 0, // Total clicks before hint(s) taken
  });

  // Clicks
  const [clicks, setClicks] = useState(0);

  // Timer
  const [timer, setTimer] = useState(0);

  // Timer increase
  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  // Check if won
  useEffect(() => {
    let index = 0;
    while (index < tiles.length) {
      if (tiles[index].filled === false) {
        setWon(false);
        break;
      }
      index += 1;
    }
    if (index === tiles.length) setWon(true);
  }, [tiles]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        getDataPoints(clicks, won);
        setMove(true);
      }
    }, 500);
  }, [won]);

  const getDataPoints = (tempClicks, tempWon) => {
    // Clicks before first right block is clicked
    // Time taken to click first right block (where all arrows are pointed
    if (datapts.firstBoxClicks === 0 && datapts.firstBoxTime === 0) {
      setDatapts({
        ...datapts,
        ...{ firstBoxClicks: tempClicks, firstBoxTime: timer },
      });
    }

    // Total Time && Total Clicks
    if (tempWon) {
      const finalObj = {
        gameData: {
          levelData: [
            {
              level: 1,
              levelName: 'Core',
              firstBoxClicks: datapts.firstBoxClicks,
              firstBoxTime: datapts.firstBoxTime,
              totalClicks: tempClicks,
              isLevelCleared: true,
              isLevelSkipped: false,
              totalTime: timer,
              totalHintsTaken: localStorage.getItem("totalHints"),
              timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
              timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
            }
          ],
        }
      }
      console.log(finalObj)
      sendResult(finalObj)
      setDatapts({
        ...datapts,
        ...{ totalClicks: tempClicks, totalTime: timer },
      });
    }
  };

  // Get correct icon according to the pattern
  const getIcon = ({ item, index }) => {
    if (
      (item.x === tiles[currentTile].x || item.y === tiles[currentTile].y) &&
      !(item.x === tiles[currentTile].x && item.y === tiles[currentTile].y)
    ) {
      return arrow;
    } else {
      return hex;
    }
  };

  // Get arrow direction
  const getDirection = ({ item, index }) => {
    if (item.x < tiles[currentTile].x) return "right";
    if (item.x > tiles[currentTile].x) return "left";
    if (item.y < tiles[currentTile].y) return "down";
    if (item.y > tiles[currentTile].y) return "up";
  };

  // Remove the correct tile and switch to next tile
  const handleClick = ({ item, index }) => {
    let tempClicks = clicks + 1;
    setClicks(clicks + 1);
    let tempTiles = [...tiles];
    // Remove if the tile selected is the correct tile
    if (item.x === tiles[currentTile].x && item.y === tiles[currentTile].y) {
      tempTiles[index].filled = true;
      setCurrentTile(PATTERN[currentIndex + 1]);
      setCurrentIndex(currentIndex + 1);
      setTiles(tempTiles);
      getDataPoints(tempClicks);
    }
    // Reset the tiles
    else {
      tiles.forEach((item, index) => {
        tempTiles[index].filled = false;
      });
      setCurrentIndex(0);
      setCurrentTile(PATTERN[0]);
      setTiles(tempTiles);
    }
  };

  return (
    <div className="component-level-dos">
      {move && <LevelComplete levelNum={1} />}
      <Navbar won={won} levelNum={1} />
      <div className="game-container">
        {tiles.map((item, index) => (
          <div
            key={index}
            className="tile"
            onClick={() => handleClick({ item: item, index: index })}
          >
            <div className="tile-inside">
              {!item.filled && (
                <img
                  className={getDirection({ item: item, index: index })}
                  src={getIcon({ item: item, index: index })}
                  alt={item.type}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LevelDos;
